/**
 * Textos de "N hojas" como UNA sola cadena. Si se arman en el JSX con varias expresiones, React crea
 * varios nodos de texto sueltos; cuando el navegador (traducción automática, extensiones) los
 * modifica, React falla al actualizarlos ("removeChild… not a child of this node"). Una cadena =
 * un nodo de texto.
 */
export function pagesWord(pages) {
    return pages === 1 ? "hoja" : "hojas";
}

/** "2 hojas (la última con celdas vacías)" para `labels` etiquetas en papel de `capacity` por hoja. */
export function sheetSummary(labels, capacity) {
    const cap = Math.max(1, capacity || 1);
    const pages = Math.ceil(Math.max(0, labels) / cap);
    return `${pages} ${pagesWord(pages)}${labels % cap !== 0 ? " (la última con celdas vacías)" : ""}`;
}
